module.exports = __webpack_public_path__ + "media/images/logo_ucv-7f5bf59f.png";